export const salesTeamStatsGridHeaders = [
  {
    sortable: true,
    text: 'Sales Person',
    value: 'SalesPerson',
  },
  {
    sortable: true,
    text: 'Total Trade',
    value: 'TotalTradeNow',
    align: 'right',
  },
  {
    sortable: true,
    text: 'Trade vs Last Yr',
    value: 'TradeVsLastYear',
    align: 'right',
  },
  {
    sortable: true,
    text: 'Trade % vs Last Yr',
    value: 'TradePercentVsLastYear',
    align: 'right',
  },
  {
    sortable: true,
    text: 'Total MSF',
    value: 'TotalMSFNow',
    align: 'right',
  },
  {
    sortable: true,
    text: 'MSF vs Last Yr',
    value: 'MsfVsLastYear',
    align: 'right',
  },
  {
    sortable: true,
    text: 'MSF % vs Last Yr',
    value: 'MsfPercentVsLastYear',
    align: 'right',
  },
]

export const salesPersonStatsGridHeaders = [
  {
    sortable: false,
    text: 'Total Trade',
    value: 'TotalTradeNow',
    align: 'right',
  },
  {
    sortable: false,
    text: 'Trade vs Last Yr',
    value: 'TradeVsLastYear',
    align: 'right',
  },
  {
    sortable: false,
    text: 'Trade % vs Last Yr',
    value: 'TradePercentVsLastYear',
    align: 'right',
  },
  {
    sortable: false,
    text: 'Total MSF',
    value: 'TotalMSFNow',
    align: 'right',
  },
  {
    sortable: false,
    text: 'MSF vs Last Yr',
    value: 'MsfVsLastYear',
    align: 'right',
  },
  {
    sortable: false,
    text: 'MSF % vs Last Yr',
    value: 'MsfPercentVsLastYear',
    align: 'right',
  },
]

export const customersStatsGridHeaders = [
  {
    sortable: true,
    text: 'Customer',
    value: 'Customer',
  },
  {
    sortable: true,
    text: 'Total Trade',
    value: 'TotalTradeNow',
    align: 'right',
  },
  {
    sortable: true,
    text: 'Trade vs Last Yr',
    value: 'TradeVsLastYear',
    align: 'right',
  },
  {
    sortable: true,
    text: 'Trade % vs Last Yr',
    value: 'TradePercentVsLastYear',
    align: 'right',
  },
  {
    sortable: true,
    text: 'Total MSF',
    value: 'TotalMSFNow',
    align: 'right',
  },
  {
    sortable: true,
    text: 'MSF vs Last Yr',
    value: 'MsfVsLastYear',
    align: 'right',
  },
  {
    sortable: true,
    text: 'MSF % vs Last Yr',
    value: 'MsfPercentVsLastYear',
    align: 'right',
  },
]

export const companyInvoicesGridHeaders = [
  {
    sortable: true,
    text: 'Invoice Date',
    value: 'invoiceDate',
    align: 'left',
  },
  {
    sortable: true,
    text: 'Salesman',
    value: 'user',
    align: 'left',
  },
  {
    sortable: true,
    text: 'Invoice #',
    value: 'invoiceNumber',
    align: 'left',
  },
  {
    sortable: true,
    text: 'Charges',
    value: 'invoiceBalance',
    align: 'right',
  },
  {
    sortable: true,
    text: 'Days Old',
    value: 'invoiceAge',
    align: 'right',
  },

]

export const agingReportGridHeaders = [
  {
    sortable: true,
    text: 'Invoices Amount',
    value: 'totalAmount',
    align: 'left',
  },
  {
    sortable: true,
    text: 'Invoices Balance',
    value: 'totalBalance',
    align: 'left',
  },
  {
    sortable: true,
    text: '31-60 days',
    value: 'totalDays31_60',
    align: 'left',
  },
  {
    sortable: true,
    text: '61-90 days',
    value: 'totalDays61_90',
    align: 'left',
  },
  {
    sortable: true,
    text: '91-120 days',
    value: 'totalDays91_120',
    align: 'left',
  },
  {
    sortable: true,
    text: 'Over 120 days',
    value: 'totalDaysOver120',
    align: 'left',
  },
]
